export const RoleRenderAutocomplete = {
  VIEW_RESOURCEONE_BY_CLASSIFICATION: 'classification',
};
